import { useContext } from 'react';
import EditSessionContext from './EditSessionContext';
const EditSessionProvider = ({ children }) => {
    const { isEditSessionActive } = useContext(EditSessionContext);
    return children(isEditSessionActive);
};
export default EditSessionProvider;
